import React from 'react';
import { Link } from 'react-router-dom';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error("Error caught by ErrorBoundary:", error, errorInfo);
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-4">
          <div className="bg-white rounded-lg shadow-xl p-6 max-w-md w-full">
            <h1 className="text-2xl font-bold text-red-600 mb-4">Something went wrong</h1>
            <p className="text-gray-700 mb-4">
              We're sorry, but there was an error loading this page. This might be due to an authentication issue.
            </p>
            <div className="bg-gray-100 p-4 rounded mb-4 overflow-auto max-h-40">
              <p className="text-sm font-mono text-gray-800">
                {this.state.error && this.state.error.toString()}
              </p>
            </div>
            <div className="flex flex-col space-y-2">
              <button 
                onClick={() => window.location.reload()} 
                className="bg-primary text-white py-2 px-4 rounded hover:bg-primary-dark transition-colors"
              >
                Refresh the page
              </button>
              <Link 
                to="/" 
                className="bg-secondary text-white py-2 px-4 rounded text-center hover:bg-secondary-dark transition-colors"
              >
                Go to Home Page
              </Link>
              <button 
                onClick={() => {
                  // Clear all storage and redirect to home
                  localStorage.clear();
                  sessionStorage.clear();
                  window.location.replace('/');
                }} 
                className="bg-red-600 text-white py-2 px-4 rounded hover:bg-red-700 transition-colors"
              >
                Reset and Go Home
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary; 